var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ma-2",attrs:{"small":"","color":"darkblue","outlined":"","title":"Back"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-arrow-left ")]),_vm._v(" Back")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }